import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => ({
  ...filter,
  includedEmojis: [
    ...(filter.includedEmojis || []),
    Array.from(insights).map((insight) => insight.name)
  ]
})

const generateEmojiInsightStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generateEmojiInsightStrategy
